import { createFileRoute } from '@tanstack/react-router';
import { PlansPage } from '~/components/pages/PlansPage';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

/** Arabic plans page. `PlansPage` reads its copy from `useContent()`, so only the head is Arabic here. */
export const Route = createFileRoute('/ar/plans')({
  head: () =>
    pageHeadMeta({
      title: 'الباقات — nsave',
      description:
        'قارن بين باقات Essential وPro وPrestige من nsave: حسابات USD وEUR وGBP، وكارت Visa، وكاش باك على مشتريات الكارت.',
      path: '/ar/plans',
      stylesheets: [pricingStylesHref],
    }),
  component: PlansPage,
});
